<template>
	<div class="container-fluid">
		<!-- reviews-title-header-->
		<div class="row bg-white">
			<div class="static-pages">
				<div class="static-pages-title">
					<!-- title -->
					<div class="container-fluid reviews p-x-lg clearfix">
						<div class="col-xs-12 col-sm-6 col-lg-6 p-a-0">
							<h1 class="text-upper">Reviews</h1>
							<h4>Learn about the different builds and experiences people have with BLD.</h4>
							<div class="reviews-rating">
								<star-rating
									:title="`Rating average: ${averageRating}`"
									:rating="averageRating"
									active-color="#FAA50B"
									inactive-color="#5F707F"
									:star-size="20"
									:show-rating="false"
									:increment="0.5"
									:border-width="1"
									border-color="#5F686D"
									:rounded-corners="false"
									:read-only="true"
									:star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
								/>                        
								<span class="reviews-rating-count">
									{{ reviewCount }} Reviews
								</span>
							</div>
						</div>
						<div class="col-xs-12 col-sm-6 col-lg-6 p-a-0 text-right btn-grid">
							<a href="#" class="btn btn-green w-clip" @click.prevent="goToWriteReview()">
								Submit a Review
							</a>
							<div class="btn-group green-drop w-clip">
								<button
									type="button"
									class="btn btn-green btn-outline dropdown-toggle first"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									Sort by Rating
								</button>
								<button
									type="button"
									class="btn btn-green dropdown-toggle"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<span class="caret" />
									<span class="sr-only">Toggle Dropdown</span>
								</button>
								<ul class="dropdown-menu list-none">
									<li>
										<a class="pointer" @click="selectedRatingReviews = 'All'">
											<p class="text-blue m-b-0">VIEW ALL REVIEWS</p>
										</a>
									</li>
									<li>
										<a class="pointer" @click="selectedRatingReviews = 5">
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
										</a>
									</li>
									<li>
										<a class="pointer" @click="selectedRatingReviews = 4">
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star" />
										</a>
									</li>
									<li>
										<a class="pointer" @click="selectedRatingReviews = 3">
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star" />
											<i class="fa fa-star" />
										</a>
									</li>
									<li>
										<a class="pointer" @click="selectedRatingReviews = 2">
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star" />
											<i class="fa fa-star" />
											<i class="fa fa-star" />
										</a>
									</li>
									<li>
										<a class="pointer" @click="selectedRatingReviews = 1">
											<i class="fa fa-star text-blue" />
											<i class="fa fa-star" />
											<i class="fa fa-star" />
											<i class="fa fa-star" />
											<i class="fa fa-star" />
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- /.title -->
				</div>
			</div>
		</div>
		<!-- /.reviews-title-header-->
		<!-- rating-options -->
		<div class="row bg-white main-row">
			<div class="static-pages-content p-t p-b-xl">
				<div class="container-fluid p-a-0">
					<div class="col-xs-12 reviews-content m-t-md">
						<template v-if="isLoading">
							<div class="container-fluid reviews p-x-lg">
								<div class="row">
									<div style="text-align:center">
										<span class="fa fa-spin fa-spinner" />
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<template v-if="reviewsList.length">
								<div class="row wrap" v-for="review in reviewsList" :key="review.id">
									<div class="container">
										<div class="row m-y-lg">
											<div class="col-md-3 col-sm-4 rate">
												<div id="static-rating-row">
													<div class="rating-reviews clearfix">
														<star-rating
															:rating="review.rating"
															active-color="#640a92"
															inactive-color="#5f686d"
															:star-size="17"
															:show-rating="false"
															:increment="0.5"
															:border-width="1"
															border-color="#640a92"
															:rounded-corners="true"
															:read-only="true"
															:star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
														/>
													</div>
												</div>
												<div class="username" :title="review.username">{{ review.username | truncate(16) }}</div>
												<div class="date">{{ review.date | humanizeDate }}</div>
												<div class="location">{{ review.state }}</div>
												<div class="number">
													<a :href="`/bld/step5?price=1500&draft=${review.bldNumber}`" target="_blank">
														BLD: {{ review.bldNumber }}
													</a>
												</div>
											</div>
											<div class="col-md-9 col-sm-8">
												<div class="row">
													<div class="col-md-12">
														<div
															class="detail"
															v-show="selectedReviewId != review.id"
														>
															{{ review.description | truncate(200, '...', false) }}
														</div>
														<div
															class="detail"
															v-show="selectedReviewId == review.id"
														>
															{{ review.description }}
														</div>
														<a
															href="#"
															class="text-green display more"
															v-show="selectedReviewId != review.id && review.description.length >= 200"
															@click.prevent="selectedReviewId = review.id"
														>
															[…more]
														</a>
														<a
															href="#"
															class="text-green display less"
															v-show="selectedReviewId == review.id"
															@click.prevent="selectedReviewId = 0"
														>
															[…less]
														</a>
													</div>
													<div class="col-md-12  m-t-md">
														<div class="part">
															<b>GPU:</b>
															<i>
																{{ review.gpu ? review.gpu.name : 'N/A' }} /
															</i>
															<b>CPU:</b>
															<i>{{ review.cpu? review.cpu.name : 'N/A' }}</i>
														</div>
														<div class="game">
															<b>GAMES</b>:
															<i>
																{{ stringifyGamesList(review.games) }}
															</i>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="row">
									<div class="static-pages-content p-t p-b-xl">
										<div class="container">
											<div class="col-xs-12 clearfix">
												<div class="col-xs-12 col-sm-6">
													<p>No reviews available.</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</template>
						</template>
						<!-- Paginator -->
						<div class="rev-pagination m-t-md" v-if="!isLoading">
							<a disabled class="text-green pag-arrow " @click="goToPage('left')">
								<i class="fa fa-chevron-left" aria-hidden="true" />
							</a>
							<div class="pag-text">
								<p class="first-number">{{ currentPage }}</p>
								<p>of</p>
								<p class="last-number">{{ totalPages }}</p>
							</div>
							<a class="text-green pag-arrow" @click="goToPage('right')">
								<i class="fa fa-chevron-right" aria-hidden="true" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Reviews",
	data() {
		return {
			currentPage: 0,
			isLoading: true,
			reviews: [],
			selectedRatingReviews: "All",
			selectedReviewId: 0,
			totalPages: 0,
			averageRating: 0,
			reviewCount: 0
		};
	},
	computed: {
		reviewsList() {
			if (this.selectedRatingReviews == "All") {
				return this.reviews;
			}

			const groupedReviews = _.groupBy(this.reviews, "rating");
			return groupedReviews[this.selectedRatingReviews] || [];
		}
	},
	watch: {
		selectedRatingReviews(val) {
			this.isLoading = true;
			val = val == "All" ? "" : val;
			this.getReviews(1, val);
		}
	},
	created() {
		this.getReviews();
	},
	methods: {
		goToWriteReview() {
			// User is not logged in
			if (!Cookies.get("cookies_id")) {
				this.$modal.show("login-modal");
				this.$router.push({ name: "UserAccount", query: {
					redirect: "/user/account",
					currentTab: "write-review"
				} });
			} else {
				this.$router.push({
					name: "UserAccount",
					query: {
						currentTab: "write-review"
					}
				});
			}
		},
		getReviews(page = 1, rating = "") {
			this.isLoading = true;
			axios({
				url: `/public-reviews?sort=created_at|desc&page=${page}&format=true&q=(rating:${rating})&limit=25`,
				method: "GET"
			}).then(reviews => {
				this.totalPages = reviews.data.total_pages;
				this.currentPage = reviews.data.page;
				this.averageRating = reviews.data.average_rating;
				this.reviewCount = reviews.data.total_items;
				this.reviews = reviews.data.data.map(review => {
					review.rating = Number(review.rating);
					return review;
				});
			}).catch(error => {
				toastr.error(error, "Error");
			}).then(() => this.isLoading = false);
		},
		goToPage(direction) {

			let currentPage = Number(this.currentPage);
			const rating = this.selectedRatingReviews == "All" ? "" : this.selectedRatingReviews;


			if (direction == "left") {
				currentPage -= 1;
			} else {
				currentPage += 1;
			}

			if (currentPage >= 1 && currentPage <= Number(this.totalPages)) {
				this.getReviews(currentPage, rating);
				$(window).scrollTop($("#fa-spinner"));
			}
		},
		stringifyGamesList(games = []) {
			let gameList = "";
			games.forEach((value, index) => {
				if (games.length == index + 1) {
					gameList = gameList + value.name;
				} else {
					gameList = gameList + value.name + ", ";
				}
			});

			return gameList;
		}
	}
};
</script>

<style lang="scss" scoped>
.reviews-rating {
    display: flex;
    align-items: baseline;
    margin-top: 10px;
    margin-left: -5px;

    &-count {
        font-size: 20px;
        margin-left: 10px;
    }

    @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
        margin-bottom: 15px;
    }
}
</style>
